import { createRouter, createWebHistory } from 'vue-router';

import Home from '../pages/Home';
import About from '../pages/About.vue';
import Streaks from '@/pages/Streaks.vue';
import Subscription from '@/pages/Subscription.vue';
import Login from '@/pages/Login.vue';
import StreakCategory from '@/pages/StreakCategory.vue';

const routes = [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/about',
      name: 'About',
      component: About
    },
    {
      path: '/streaks',
      name: 'Streaks',
      component: Streaks
    },
    {
      path: '/streaks/:categorySlug',
      name: 'StreakCategory',
      component: StreakCategory
    },
    {
      path: '/subscription',
      name: 'Subscription',
      component: Subscription
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    }
  ]

  const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes // short for `routes: routes`
  });

  // Add navigation guard
  router.beforeEach((to, from, next) => {
    const token = localStorage.getItem('rockstar_token');
    const user = localStorage.getItem('rockstar_user');
    
    if (!token || !user) {
      if (to.name !== 'Login') {
        return next({ name: 'Login' });
      }
    } else {
      if (to.name === 'Login') {
        return next({ name: 'Home' }); 
      }
    }
    next();
  });

export default router;